const mugicsSVGCreature = `
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="54.506px" height="56.304px" viewBox="0 0 54.506 56.304" enable-background="new 0 0 54.506 56.304" xml:space="preserve">
<g id="Layer_1">
	<g>
		<defs>
			<rect id="SVGID_6_" x="197.245" y="-349.696" width="1922" height="474"/>
		</defs>
		<clipPath id="SVGID_2_">
			<use xlink:href="#SVGID_6_"  overflow="visible"/>
		</clipPath>
		<g clip-path="url(#SVGID_2_)">
		</g>
	</g>
	<g>
		<g>
			<path fill="#6A5DA8" d="M41.178,30.88c1.38-2.517,2.138-5.527,2.138-8.861c0,0-0.065-18.062-0.161-18.266
				C42.857,1.555,41.063,0,38.828,0c-2.446,0-4.457,1.741-4.567,4.143c-0.019,0.111-0.34,18.183-0.34,18.183
				c0,4.819-2.379,8.102-6.889,8.102c-4.513,0-7.034-3.283-7.034-8.102c0,0,0.011-18.359-0.082-18.561
				C19.623,1.562,17.864,0,15.626,0c-2.414,0-4.372,1.698-4.526,4.049c-0.03,0.136-0.32,17.969-0.32,17.969
				c0,3.406,1.064,6.471,2.5,9.02c-5.056,1.878-8.111,6.179-8.111,12.11c0,7.928,5.872,13.156,13.886,13.156h16.532
				c8.014,0,13.75-5.313,13.75-13.325C49.336,37.149,46.172,32.869,41.178,30.88z"/>
			<g>
				<path fill="#FFFFFF" d="M42.768,43.105c0,3.985-3.229,7.214-7.213,7.214h-16.52c-3.984,0-7.214-3.229-7.214-7.214l0,0
					c0-3.985,3.229-7.214,7.214-7.214h16.52C39.538,35.891,42.768,39.12,42.768,43.105L42.768,43.105z"/>
				<path fill="#221F1F" d="M19.81,43.625c0,1.08-0.879,1.96-1.961,1.96l0,0c-1.083,0-1.963-0.88-1.963-1.96v-2.163
					c0-1.083,0.88-1.961,1.963-1.961l0,0c1.082,0,1.961,0.878,1.961,1.961V43.625z"/>
				<path fill="#221F1F" d="M39.013,43.488c0,1.082-0.879,1.962-1.963,1.962l0,0c-1.083,0-1.962-0.88-1.962-1.962v-2.163
					c0-1.081,0.879-1.96,1.962-1.96l0,0c1.084,0,1.963,0.879,1.963,1.96V43.488z"/>
			</g>
		</g>
		<g>
			<path fill="#EAEAEA" d="M6.782,32.897c0.788,0,1.453,0.243,2.06,0.667c0.605-9.75,8.6-17.26,18.411-17.26
				c9.872,0,17.806,7.51,18.41,17.26c0.605-0.424,1.272-0.667,2.06-0.667h1.03c0.061,0,0.061,0,0.12,0
				c-0.908-11.204-10.175-19.864-21.62-19.864c-11.446,0-20.714,8.66-21.621,19.864c0.061,0,0.061,0,0.121,0H6.782z"/>
			<path fill="#EAEAEA" d="M52.265,38.106v2.968v2.482v2.968c1.394-0.969,2.241-2.483,2.241-4.179
				C54.506,40.59,53.658,39.075,52.265,38.106z"/>
			<path fill="#EAEAEA" d="M48.753,34.23h-1.03c-1.211,0-2.24,0.969-2.24,2.241v11.931c0,1.211,0.97,2.241,2.24,2.241h1.03
				c1.21,0,2.239-0.969,2.239-2.241V36.411C50.992,35.199,50.023,34.23,48.753,34.23z"/>
			<path fill="#EAEAEA" d="M0,42.285c0,1.695,0.848,3.271,2.239,4.179v-2.968v-2.482v-2.968C0.848,39.075,0,40.59,0,42.285z"/>
			<path fill="#EAEAEA" d="M9.023,36.411c0-1.211-0.97-2.241-2.241-2.241H5.753c-1.211,0-2.241,0.969-2.241,2.241v11.931
				c0,1.211,0.969,2.241,2.241,2.241h1.029c1.212,0,2.241-0.97,2.241-2.241V36.411z"/>
		</g>
		<g>
			<path fill="#6A5DA8" d="M19.998,22.325c0,0,0.011-18.359-0.082-18.561C19.623,1.562,17.864,0,15.626,0
				c-2.414,0-4.372,1.698-4.526,4.049c-0.03,0.136-0.32,17.969-0.32,17.969c0,2.169,0.435,4.197,1.118,6.044
				c3.735,0.604,7.583,1.123,11.433,1.408C21.167,28.163,19.998,25.601,19.998,22.325z"/>
			<path fill="#6A5DA8" d="M43.315,22.019c0,0-0.065-18.062-0.161-18.266C42.857,1.555,41.063,0,38.828,0
				c-2.446,0-4.457,1.741-4.567,4.143c-0.019,0.111-0.34,18.183-0.34,18.183c0,3.473-1.241,6.14-3.621,7.364
				c4.171-0.068,8.25-0.534,12.082-1.615C42.989,26.223,43.315,24.191,43.315,22.019z"/>
		</g>
	</g>
</g>
<g id="LiveTXT" display="none">
</g>
<g id="GRids" display="none">
</g>
</svg>
`;

export default mugicsSVGCreature;



// WEBPACK FOOTER //
// ./src/Components/Modals/Video/images/mugicsCreatureSVG.js